import React, { useEffect } from 'react';
import { useState } from 'react';
import { Filter } from '../../../models/filter/filter';
import { Api } from '../../../services/api';
import { Notify } from '../../../services/notification/notify';
import { Select } from './select';

export const SelectQuery = ({
    value,
    onChange,
    restEndpoint,
    pluralResourceName,
    constantOptions,
    maxResults = 50,
    disabledFunction = (raw) => false,
    justName = false,
    nameFunction = (raw) => raw.name,
    ...props
}) => {
    const getData = () => {
        const filter = new Filter({
            query: searchStatus ? query : null,
            page: 0,
            pageSize: maxResults,
            sort: null,
            scope: null,
            filters: {},
        });
        setLoading(true);

        Api.get(restEndpoint, { q: JSON.stringify(filter) })
            .then((json) => {
                setData(json.content);

                setLoading(false);
            })
            .catch((e) => {
                console.error(e);
                Notify.error(
                    `Error searching for ${pluralResourceName}`,
                    `An error occurred while trying search for ${pluralResourceName}.`
                );
                setLoading(false);
            });
    };

    const processEntry = (r) => {
        return r == null
            ? null
            : justName
            ? nameFunction(r)
            : { ...r, value: nameFunction(r), disabled: disabledFunction(r) };
    };

    const options = () => {
        const processed = [...(constantOptions ?? []), ...data.map(processEntry).filter(Boolean)];
        if (justName) {
            // Remove duplicates when justName is true
            return Array.from(new Set(processed));
        }
        return processed;
    };

    const onSearch = (v) => {
        setQuery(v);
    };

    const onSearchStatus = (v) => {
        if (v !== searchStatus) {
            setSearchStatus(v);
            getData();
        }
    };

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [query, setQuery] = useState('');
    const [givenValue, setGivenValue] = useState(processEntry(value));
    const [searchStatus, setSearchStatus] = useState(false);

    useEffect(() => {
        setLoading(true);
        const timeout = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(timeout);
    }, [query]);

    useEffect(() => {
        if (justName && givenValue !== value) {
            setGivenValue(value)
        } if (givenValue?.id !== value?.id) {
            setGivenValue(value);
        }
    }, [value]);

    return (
        <Select
            value={givenValue}
            onChange={onChange}
            options={options()}
            onSearch={onSearch}
            onSearchStatus={onSearchStatus}
            loading={loading}
            {...props}
        />
    );
};
